import React, { PureComponent } from 'react';
// import { Calendar } from 'react-date-range';
import DayPicker from 'react-day-picker';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import CalendarIcon from './presentational/calendar_icon';
import GeneralSprite from '../../../../images/general.svg';

const Navbar = ({ onPreviousClick, onNextClick, className }) => {
  console.log(onPreviousClick, onNextClick);
  return (
    <ul className={className}>
      <li className="DayPicker__nav-item">
        <button className="DayPicker__btn DayPicker__btn--previous" type="button" onClick={() => onPreviousClick()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 21.7 39"
            className="DayPicker__icon DayPicker__icon--left-arrow"
          >
            <title>Previous Item</title>
            <use href={`${GeneralSprite}#move-left`} />
          </svg>
        </button>
      </li>
      <li className="DayPicker__nav-item">
        <button className="DayPicker__btn DayPicker__btn--next" type="button" onClick={() => onNextClick()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 21.7 39"
            className="DayPicker__icon DayPicker__icon--right-arrow"
          >
            <title>Next Item</title>
            <use href={`${GeneralSprite}#move-right`} />
          </svg>
        </button>
      </li>
    </ul>
  );
};

Navbar.propTypes = {
  onPreviousClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
};

class CalendarHolder extends PureComponent {
  static propTypes = {
    device: PropTypes.string.isRequired,
    date: PropTypes.instanceOf(Date).isRequired,
    GetSessionsData: PropTypes.func.isRequired,
    SelectDate: PropTypes.func.isRequired,
  };

  state = { open: false };

  onChange = date => {
    const { GetSessionsData, SelectDate } = this.props;

    GetSessionsData(date);
    SelectDate(date);
    this.setState({ open: false });
  };

  openCalendar = e => {
    e.preventDefault();
    this.setState(({ open }) => ({ open: !open }));
  };

  _formatDate() {
    const { device, date } = this.props;
    if (device !== 'mobile') {
      return format(date, 'MMMM');
    }
    return '';
  }

  render() {
    const { open } = this.state;
    const { date } = this.props;
    return (
      <div className="calendar-btn">
        <button onClick={this.openCalendar} type="button">
          <CalendarIcon title={this._formatDate()} />
          <span className="month-str">{this._formatDate()}</span>
        </button>
        <div className="calendar-holder">
          {open && (
            <DayPicker
              disabledDays={[{ before: new Date() }]}
              navbarElement={Navbar}
              onDayClick={this.onChange}
              selectedDays={date}
            />
          )}
        </div>
      </div>
    );
  }
}

export default CalendarHolder;
